import { createI18n } from 'vue-i18n'
import { messages, defaultLocale } from '../locales'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $t: typeof i18n.global.t
  }
}

/**
 * 在 ​​非组件环境​​（如 Vuex/Pinia、工具函数、路由守卫等）使用
 * @param message 
 * @returns 
 */
export function translate(message: any = '') {
  if (!message) {
    return ''
  }
  return i18n.global.t.call(i18n.global.locale, message)
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: defaultLocale,
  fallbackLocale: 'en-US',
  messages,
})

export default i18n
